import React from 'react'

const RightArrow = ({ isActive }) => {
    return (
    <svg
                        width="20"
                        height="20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <polygon
                            points="5,2 15,10 5,18"
                            style={{
                                fill: isActive ? "#e7f4ff" : "#f8f8f8",
                                stroke: "#b3b2b4",
                                strokeWidth: 1,
                                strokeDasharray: "25, 20",
                            }}
                        />
                    </svg>
    )
}

export default RightArrow